<template>
    <u-card-flat-tile v-bind="$attrs">
        <template v-for="(_, slotName) in $slots" #[slotName]>
            <slot :name="slotName" />
        </template>
    </u-card-flat-tile>
</template>

<script>
import UCardFlatTile from "@/components/publish/styles/cards/u-card-flat-tile.vue";

export default {
    props: {},
    components: {
        UCardFlatTile,
    },
    data() {
        return {};
    },
    mounted() {},
    methods: {},
};
</script>

<style lang="scss" scoped></style>
